var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"absolute":"","color":"primary","elevate-on-scroll":"","scroll-target":"#scrolling-techniques-7"}},[_c('v-spacer'),_c('AuthNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }